// extracted by mini-css-extract-plugin
export default {"serie":"c_q_aEx","serie_image":"c_r_60G","serie_name":"c_s_26B"};